
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.5 22H.5a.5.5 0 01-.5-.5V5.53a1.5 1.5 0 011.5-1.5h7.2a1.52 1.52 0 011.08.46l1.96 2.03a.5.5 0 11-.73.7L9.06 5.17a.5.5 0 00-.36-.15H1.5a.5.5 0 00-.5.5V21h13.5a.5.5 0 010 1zm9-10.48a.5.5 0 01-.5-.5v-2.5a.5.5 0 00-.5-.5h-1.36a.5.5 0 010-1h1.36a1.5 1.5 0 011.5 1.5v2.5a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M17.97 13.51a.5.5 0 01-.25-.06.5.5 0 01-.19-.69l3.29-5.68-6.75-3.9-3.89 6.75 4.6 2.65a.5.5 0 11-.5.87l-5.03-2.9a.5.5 0 01-.18-.69l4.39-7.61a.5.5 0 01.68-.18l7.61 4.39a.5.5 0 01.18.68l-3.53 6.12a.5.5 0 01-.43.25z"}}),_c('path',{attrs:{"d":"M21.5 22H.5a.5.5 0 01-.49-.61l2-8.5a.5.5 0 01.49-.38h21a.5.5 0 01.49.62l-2 8.49a.5.5 0 01-.49.38zM1.13 21H21.1l1.76-7.49H2.9z"}})])
          )
        }
      }
    